import React from "react";
import styles from "./loader.scss";
import PropTypes from "prop-types";
import classNames from "../../utils/classNames";

export default function Loader(props) {
    const {dark} = props;
    return (
        <div className={classNames(styles.loader, {
            [styles.dark]: dark,
        })}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
};

Loader.propTypes = {
    dark: PropTypes.bool
};

